import { useEffect, useState } from 'react';
import { toastSuccess } from '../utils/toasts';
import { useCloneEventMutation } from '../store';
import CustomModal from './atoms/CustomModal';
import EventDTO from '../models/event';
import Button from './atoms/Button';
import Input from './atoms/Input';

interface CloneEventProps {
  event: EventDTO;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const CloneEvent = ({ event, isOpen, setIsOpen }: CloneEventProps) => {
  const [cloneEvent, { isLoading, data }] = useCloneEventMutation();
  const [name, setName] = useState(`Copia de ${event.name}`);

  const handleCloneEvent = async () => {
    await cloneEvent({ businessId: event.business_id, eventId: event.id, name });
  };

  useEffect(() => {
    if (data?.data) {
      setIsOpen(false);
      toastSuccess('Evento clonado correctamente');
      window.location.href = `${window.location.origin}/admin/${data.data.event.business_id}/events/${data.data.event.id}`;
    }
  }, [data, setIsOpen]);

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false);
      }}
      hideCancelButton
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <h1>Clonar evento</h1>
          <p>Ingresa el nombre del evento clonado</p>
          <Input
            id="name"
            label="Nombre del evento"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="flex flex-row gap-2">
          <Button onClick={() => setIsOpen(false)} variant="secondary">Cancelar</Button>
          <Button onClick={handleCloneEvent} loading={isLoading}>
            {isLoading ? 'Clonando...' : 'Clonar'}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default CloneEvent;
